import { Grid, Typography } from '@mui/material'
import { InstallationList } from 'common/types/kraken-core/Installation'

export interface InstallationItemResultProps {
  installation: InstallationList
}

export const InstallationItemResult = ({ installation }: InstallationItemResultProps) => {
  return (
    <Grid container spacing={1} alignItems={'center'}>
      <Grid item>
        <Typography variant="body2">{installation.name}</Typography>
      </Grid>
    </Grid>
  )
}
